import React from "react";
import { useTranslation } from "../i18n";

export default function Contact() {
  const { t } = useTranslation();
  
  return (
    <section className="container mx-auto px-6 pt-32 pb-20">
      <div className="max-w-2xl mx-auto">
        <h1 className="text-4xl font-bold text-gray-900 mb-6">
          {t("contact.title")}
        </h1>
        
        <p className="text-lg text-gray-600 mb-8">
          {t("contact.description")}
        </p>

        <div className="bg-white border rounded-2xl shadow-sm p-8 space-y-6">
          <div>
            <h3 className="font-semibold text-gray-900 mb-2">
              📞 {t("contact.phone")}
            </h3>
            <a 
              href="tel:+41790000000" 
              className="text-emerald-600 hover:text-emerald-700 font-medium"
            >
              +41 79 960 60 94
            </a>
          </div>

          <div>
            <h3 className="font-semibold text-gray-900 mb-2">
              ✉️ {t("contact.email")}
            </h3>
            <a 
              href="mailto:info@van-2-go.ch" 
              className="text-emerald-600 hover:text-emerald-700 font-medium"
            >
              info@van-2-go.ch
            </a>
          </div>

          <div>
            <h3 className="font-semibold text-gray-900 mb-2">
              ⏰ {t("contact.hours")}
            </h3>
            <p className="text-gray-600">7j/7, 8h-20h</p>
          </div>

          <div className="pt-6 border-t">
            <p className="text-sm text-gray-500">
              Formulaire de réservation à venir prochainement.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
